import { render, staticRenderFns } from "./PrmList.vue?vue&type=template&id=08ca1842&"
import script from "./PrmList.vue?vue&type=script&lang=js&"
export * from "./PrmList.vue?vue&type=script&lang=js&"
import style0 from "./PrmList.vue?vue&type=style&index=0&id=08ca1842&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports